import pulse from '@finn-no/pulse-sdk';
import { Trans } from '@lingui/react/macro';
import '@warp-ds/components/icon';
import { Button, Modal } from '@warp-ds/react';
import { useState } from 'react';
import { useModalSizingHelper } from '../hooks/useModalSizingHelper.js';
import { getHuckConfig } from '../utils/getHuckConfig.js';

interface PreviewButtonProps {
  className?: string;
}

export const PreviewButton = ({ className }: PreviewButtonProps) => {
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const config = getHuckConfig();
  const { orgId, mode, brand, itemId, development, locale } = config;
  const isEditMode = mode === 'edit';
  const isRepublishMode = mode === 'republish';
  const showPreview = !isEditMode && !isRepublishMode;

  const modalStyles = useModalSizingHelper();

  const handlePreview = () => {
    if (development) {
      window.open(
        `https://dev.${brand}.no/mobility/item/${itemId}/preview?webview=true`,
        '_blank',
        'noopener,noreferrer',
      );
    } else {
      pulse.trackEvent({
        type: 'Click',
        intent: 'Show',
        name: 'Show ad preview',
        object: {
          id: 'TAI_ev03',
          type: 'UIElement',
          elementType: 'Button',
        },
      });

      setShowPreviewModal(true);
    }
  };

  return (
    <>
      {showPreview ? (
        <Button fullWidth secondary onClick={handlePreview} className={className}>
          <div className="flex items-center justify-center gap-8">
            <w-icon name="EyeOn" size="medium" locale={locale} />
            <Trans id="mobility-item-insertion.button.preview" comment="Button text for showing preview of the ad">
              See preview
            </Trans>
          </div>
        </Button>
      ) : null}
      <Modal
        open={showPreviewModal}
        title={
          <h2>
            <Trans
              id="mobility-item-insertion.ad-preview.header"
              comment="Title text in the modal that shows the ad preview"
            >
              Ad preview
            </Trans>
          </h2>
        }
        onDismiss={() => setShowPreviewModal(false)}
        right={true}
        footer={
          <Button style={{ margin: '0 auto' }} onClick={() => setShowPreviewModal(false)}>
            <Trans
              id="mobility-item-insertion.ad-preview.modal.close.button"
              comment="Button shown on the bottom of the preview modal "
            >
              Close ad preview
            </Trans>
          </Button>
        }
        style={modalStyles}
      >
        <iframe
          src={`/mobility/item/${itemId}/preview?webview=true${orgId ? `&orgId=${orgId}` : ''}`}
          className="w-full h-full"
          title="Ad preview"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        />
      </Modal>
    </>
  );
};
